export default __webpack_public_path__ + "static/media/desktop_dr_02.75b9b279.png";